<template>
  <router-link :to="getNextChatUrl(nextChatId)" replace class="notification" v-if="!isPreview()">
    <div @click="makeChatActive(nextChatId)" class="notification__wrapper">
      <div class="notification__icon">
        <img src="@/assets/images/conversation.svg" alt="" />
      </div>
      <div class="notification__text">
        <p class="notification__header">{{ textHeader }}</p>
        <p class="notification__desc">{{ textDesc }}</p>
      </div>
    </div>
  </router-link>
  <!-- / notification -->
</template>

<script>
export default {
  name: "Notification",
  props: {
    textHeader: String,
    textDesc: String,
    badge: String,
    nextChatId: String
  },
  methods: {
    makeChatActive(chatId) {
      const chat = this.$store.getters.getChatById(this.$router.currentRoute.params.id);
      Event.fire("chat-changed");

      if (chat.newData) {
        const newNotification = chat.newData.notification;
        const newMessages = chat.newData.messages;
        const newScript = chat.newData.script;
        
        this.$store.dispatch("setNewChatData", {
          notification: newNotification,
          messages: newMessages,
          script: newScript,
        });

        this.$store.dispatch("insertNewChatData", {
          import: chat.newData.import,
          chatId: chatId
        });
      }

      this.$store.dispatch("makeChatActive", {
        chatId: chatId
      });
      this.$store.dispatch("hideNotificationMessage", {
        chatId: this.$route.params.id
      });
    },
    getNextChatUrl(nextChatId) {
      const { token } = this.$route.query;
      let url = `/${this.$route.params.phone_number}`;

      if (nextChatId) {
        url = `${url}/chat/${nextChatId}`;
      }

      if (token) {
        url = `${url}?token=${token}`;
      }

      return url;
    },
    isPreview() {
      const mode = this.$store.getters.getMode;
      return mode && mode === 'preview';
    }
  }
};
</script>

<style scoped lang="scss">
.notification {
  position: fixed;
  display: block;
  z-index: 100;
  width: 100%;
  left: 0%;
  top: 0%;

  &__wrapper {
    @include flex(flex-start, center, nowrap);
    box-shadow: 0 0 25px 0 rgba(0, 0, 0, 0.1);
    background-color: $color-primary;
    color: $txt-color-alt;
    max-width: $grid-max-width;
    margin-right: auto;
    margin-left: auto;
    padding: 30px;
    width: 100%;
  }

  &__icon {
    margin-right: 20px;
    position: relative;
    min-width: 37px;
    height: 30px;
    width: 37px;

    img,
    svg {
      object-fit: contain;
      height: 100%;
      width: 100%;
    }
  }

  &__text {
    width: calc(100% - 20px - 37px);
  }

  &__header {
    letter-spacing: 0.52px;
    font-family: $font-alt;
    margin-bottom: 5px;
    line-height: 1.3;
    font-weight: 700;
    font-size: 13px;

    @media #{$bigger-mobile} {
      font-size: 15px;
    }
  }

  &__desc {
    font-family: $font-main;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-weight: 400;
    line-height: 1.3;
    overflow: hidden;
    font-size: 11px;
    width: 100%;

    @media #{$bigger-mobile} {
      font-size: 13px;
    }
  }
}
</style>